export const STORE_KEY_REMEMBER_TOKEN = 'remember_token';
export const STORE_KEY_USER_INFO = 'user_info';
